export const PaymentStatusTypes = {
  NOT_PAID: 1,
  PAID: 2,
  PARTIALLY: 3,
  labels: {
    1: 'не оплачен',
    2: 'оплачен',
    3: 'частично',
  },
};

export const PAYMENT_STATUS_OPTIONS = [
  { id: PaymentStatusTypes.NOT_PAID, label: PaymentStatusTypes.labels[1] },
  { id: PaymentStatusTypes.PAID, label: PaymentStatusTypes.labels[2] },
  { id: PaymentStatusTypes.PARTIALLY, label: PaymentStatusTypes.labels[3] },
];
